export default __webpack_public_path__ + "static/media/loadingMundi-1--unscreen.a02d8482.gif";